/* This FaqTemplate requires Tailwind CSS v2.0+ */
import { Disclosure } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/outline';
import useLocale from 'next-translate/useTranslation';

import clsxm from '@/lib/clsxm';

import MarkdownBlock from './Chat/MarkdownBlock';

const faqs = [
  {
    question: 'Who is the Teams Package intended for?',
    answer:
      'The Teams Package is targeted at businesses of all sizes that want to integrate AI solutions into their workflows. It is ideal for teams looking to enhance productivity, streamline processes, and innovate through AI-driven insights and automation.',
  },
  {
    question: 'What is the pricing structure for the Teams Package?',
    answer:
      'The pricing for the Teams Package is tiered based on the number of users and the level of features required (Teams, Teams 200, Teams 300). Please contact our sales team for a customized quote based on your specific needs.',
  },
  {
    question: 'Can the custom bot be integrated with other software?',
    answer:
      'Yes, Easy-Peasy.AI offers a range of integrations with popular business tools and software. We also provide API access for custom integrations. For specific integration requests, please consult our technical support team.',
  },
  {
    question: 'How does Easy-Peasy.AI ensure data security?',
    answer:
      'We implement industry-standard security protocols, including end-to-end encryption, secure data storage, and regular security audits. Only authorized personnel have access to sensitive data, ensuring your information is protected at all times.',
  },
  {
    question: 'What kind of support is available for Teams Package users?',
    answer:
      'Teams Package users receive priority support, including access to a dedicated account manager and technical support. We also offer onboarding assistance and continuous training resources to ensure your team can effectively use our tools.',
  },

  {
    question: 'Who can I contact for more information?',
    answer:
      'For more information, you can reach out to our support team via email at support@easy-peasy.ai or through our contact form on the website. We are here to assist you with any questions or concerns.',
  },
];

export default function FaqTranscription() {
  const { t, lang } = useLocale('common');

  if (lang !== 'en') return null;

  return (
    <div className='bg-gray-50 dark:bg-slate-900'>
      <div className='mx-auto max-w-7xl px-4 py-12 sm:px-6 sm:py-16 lg:px-8'>
        <div className='mx-auto max-w-3xl divide-y-2 divide-gray-200 dark:divide-slate-600'>
          <h2 className='text-center text-3xl font-bold tracking-tight text-gray-900 dark:text-slate-200 sm:text-4xl'>
            {t('Frequently asked questions')}
          </h2>
          <dl className='mt-6 space-y-6 divide-y divide-gray-200 dark:divide-slate-600'>
            {faqs.map((faq) => (
              <Disclosure as='div' key={faq.question} className='pt-6'>
                {({ open }) => (
                  <>
                    <dt className='text-lg'>
                      <Disclosure.Button className='flex w-full items-start justify-between text-left text-gray-400 dark:text-slate-400'>
                        <span className='font-medium text-gray-900 dark:text-slate-200'>
                          {faq.question}
                        </span>
                        <span className='ml-6 flex h-7 items-center'>
                          <ChevronDownIcon
                            className={clsxm(
                              open ? '-rotate-180' : 'rotate-0',
                              'h-6 w-6 transform'
                            )}
                            aria-hidden='true'
                          />
                        </span>
                      </Disclosure.Button>
                    </dt>
                    <Disclosure.Panel as='dd' className='mt-2 pr-12'>
                      <div className='text-base text-gray-500 dark:text-slate-400'>
                        <MarkdownBlock
                          message={faq.answer.replace(/\n/g, '  \n')}
                        />
                      </div>
                    </Disclosure.Panel>
                  </>
                )}
              </Disclosure>
            ))}
          </dl>
        </div>
      </div>
    </div>
  );
}
